import { useEffect, useCallback } from 'react';

export const useSaveShortcut = (onSave: () => void, enabled = true) => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      const isModifierPressed = event.ctrlKey || event.metaKey;
      const isEnterPressed = event.key === 'Enter';

      if (enabled && isModifierPressed && isEnterPressed) {
        event.preventDefault();
        event.stopPropagation();
        onSave();
      }
    },
    [enabled, onSave]
  );

  useEffect(() => {
    if (!enabled) return;

    // Use capture phase to intercept the event before it reaches other handlers
    document.addEventListener('keydown', handleKeyDown, true);

    return () => {
      document.removeEventListener('keydown', handleKeyDown, true);
    };
  }, [enabled, handleKeyDown]);
};
